import React, { useState } from 'react';

import { Button } from '@/lib/base/buttons/button';
import { Dropdown } from '@/lib/base/overlays/dropdown';

import { useTheme } from '../contexts/ThemeContext';

export const ThemeToggle: React.FC = () => {
  const { setTheme, isDark } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown.Root isOpen={isOpen} onOpenChange={setIsOpen}>
      <Button color='tertiary' size='sm' className='rounded-full'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          className='h-5 w-5'
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
          width='24'
          height='24'
        >
          {isDark ? (
            // Moon icon for dark mode
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z'
            />
          ) : (
            // Sun icon for light mode
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z'
            />
          )}
        </svg>
      </Button>
      <Dropdown.Popover>
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => {
              setTheme('light');
              setIsOpen(false);
            }}
          >
            Light
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              setTheme('dark');
              setIsOpen(false);
            }}
          >
            Dark
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              setTheme('system');
              setIsOpen(false);
            }}
          >
            System
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown.Root>
  );
};
